import React from 'react';
// Components
import Navbar from '../../../components/nav/Navbar';
import MailingAdminPageMainContainer from '../../../components/mailing/admin/MailingAdminPageMainContainer';
import { HelmetItem } from '../../../components/utils/HelmetItem';

function MailingAdminPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Newsletter Admin'
        desc='Internal admin page for managing newsletter subscriptions.'
        noIndex={true}
      />

      {/* Page */}
      <div
        className='grid relative min-h-screen max-h-screen overflow-y-auto font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'
        aria-label='Mailing Admin Page'
      >
        <div className='grid grid-rows-reg overflow-hidden'>
          {/* Navigation */}
          <Navbar />

          {/* Main content */}
          <main role='main'>
            <MailingAdminPageMainContainer />
          </main>
        </div>
      </div>
    </>
  );
}

export default MailingAdminPage;
